import { useState, useEffect } from 'react';

export default function MorningstarRating({rating}) {

    const showStarRating = () => {
        let numString;

        switch (rating) {
            case 1:
                numString = 'One';
                break;
            case 2:
                numString = 'Two';
                break;
            case 3:
                numString = 'Three';
                break;
            case 4:
                numString = 'Four';
                break;
            case 5:
                numString = 'Five';
                break;
        }

        return <div className={`ajb-rating-star--${numString.toLowerCase()}`} role="img" aria-label={`Morning Star Rating ${numString} Star`} data-testid="morningStarRating"></div>;
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0">
            <h2 className="card-title" data-testid="morningStarRatingHeader">
                Morningstar rating
                <sup className="h7"><small>TM</small></sup>
            </h2>
            {rating ? showStarRating() : null}
            <hr/>
        </div>
    </div>

}